import * as React from "react";
const SvgSpeechBubbleArrow = (props) => /* @__PURE__ */ React.createElement("svg", { width: 116, height: 38, viewBox: "0 0 116 38", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M115.797 37.5L63.8879 0L0 5L115.797 37.5Z", fill: "white" }));
export default SvgSpeechBubbleArrow;
